<template>
	<div id="app" class="pixelart">
		<Header/>
		<!-- <div id="nav">
			<router-link to="/">Home</router-link> |
			<router-link to="/about">About</router-link> |
			<router-link to="/levelconfig">Level Config</router-link>
		</div> -->
		<Intro/>
		<router-view/>
	</div>
</template>

<script>
// import Tabs from '@/components/Tabs'
import Header from '@/components/Header'
import Intro from '@/components/Intro'

export default {
	components: {
		// Tabs,
		Header,
		Intro
	},
	data() {
		return {
			version: 'ALPHA 1.2.0',
		}
	}
}
</script>

<style lang="scss">
@import './assets/css/reset.css';
@import './assets/fonts/NBP-Informa-FiveSix/NBP-Informa-FiveSix.css';
@import './assets/fonts/Windows-Command-Prompt/Windows-Command-Prompt.css';
// @import './assets/scss/_variables.scss';
@import './assets/scss/_utility.scss';
@import './assets/scss/_scrollbar.scss';

#app {
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	background-color: #151718;
	color: #e8e6e3;
	font-family: Avenir, Helvetica, Arial, sans-serif;
	line-height: 1.2;
	min-height: 100vh;
	position: relative;
}

#nav {
	text-align: center;
	color: #2c3e50;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}

* {
	box-sizing: border-box;
}

h1 {
	font-size: 1.8rem;
}

h2 {
	font-size: 1.4rem;
}

main {
	// padding: 0 40px 40px;
	padding: 40px;
}
</style>
